import { Bone, Card, CardAside, CardMain, CardRoute, FiltersColumn, Layout, List } from "./style";

/**
 * FE-02 — вместо трёх точек на пустом экране показываем структуру страницы.
 * Геометрия плейсхолдеров повторяет реальный контент, поэтому при подстановке
 * данных высота не скачет (CLS).
 */

const Skeleton = ({ width, height, radius, mb }) => (
  <Bone aria-hidden="true" $width={width} $height={height} $radius={radius} $mb={mb} />
);

const FlightCardSkeleton = () => (
  <Card>
    <CardMain>
      <CardRoute>
        <Skeleton width={96} height={20} />
        <Skeleton width={140} height={14} />
      </CardRoute>
      <CardRoute>
        <Skeleton width={88} height={28} />
        <Skeleton width="100%" height={12} />
        <Skeleton width={88} height={28} />
      </CardRoute>
      <CardRoute>
        <Skeleton width={110} height={14} />
        <Skeleton width={96} height={14} />
        <Skeleton width={124} height={14} />
      </CardRoute>
    </CardMain>
    <CardAside>
      <Skeleton width={140} height={12} />
      <Skeleton width="100%" height={26} />
      <Skeleton width="100%" height={44} radius={8} />
    </CardAside>
  </Card>
);

const FiltersSkeleton = () => (
  <FiltersColumn>
    {[0, 1, 2].map(group => (
      <div key={group} style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        <Skeleton width={120} height={14} />
        <Skeleton width="100%" height={12} />
        <Skeleton width="80%" height={12} />
        <Skeleton width="60%" height={12} />
      </div>
    ))}
  </FiltersColumn>
);

/** Экран ожидания выдачи: колонка фильтров + пять карточек рейсов. */
const SearchResultsSkeleton = ({ count = 5 }) => (
  <Layout role="status" aria-busy="true" aria-live="polite">
    <FiltersSkeleton />
    <List>
      {Array.from({ length: count }, (_, index) => (
        <FlightCardSkeleton key={index} />
      ))}
    </List>
  </Layout>
);

Skeleton.FlightCard = FlightCardSkeleton;
Skeleton.Filters = FiltersSkeleton;
Skeleton.SearchResults = SearchResultsSkeleton;

export default Skeleton;
export { FlightCardSkeleton, SearchResultsSkeleton };
